import React from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';

import PushToSalesforceButton from './PushToSalesforceButton';
import Button from '../../../Buttons/Button';
import Skeleton from '../../../Skeleton';
import QuickViewCloseButton from '../../QuickViewCloseButton';

import { historyPrevItem, handleCleanupRequests } from '../../actions';
import { showBackBtnSelector, activeEntitySelector, permissionsSelector } from '../../selectors';
import { truncateTicker } from '../../../../utils/helpers';

const PubPreHeader = ({
  publisher,
  settings,
  salesforceAccountUrl,
  isLoading,
  onSalesforceButtonClick,
  onClose,
}) => {
  const dispatch = useDispatch();

  const isShowBackBtn = useSelector(showBackBtnSelector);
  const activeEntity = useSelector(activeEntitySelector);
  const permissions = useSelector(permissionsSelector);

  const pubPageLink = `${window.location.origin}/publishers/${activeEntity.store}/${activeEntity.ref_no}`;
  const companyPageLink = `${window.location.origin}/companies/${publisher.company_id}`;

  const handleBack = () => dispatch(historyPrevItem());

  return (
    <div className="prospects-sidebar__preheader">
      <div className="prospects-sidebar__preheader-btns">
        {isShowBackBtn && (
          <Button shape="square" variant="secondary" className="back-btn" onClick={handleBack}>
            <span className="hicon-angle-down-new" />
          </Button>
        )}
        <Button variant="primary" href={pubPageLink} onClick={handleCleanupRequests}>
          View Publisher
        </Button>
        {!!publisher.company_id && (
          <Button variant="secondary" href={companyPageLink} onClick={handleCleanupRequests}>
            View Company{' '}
            {publisher.bloomberg_ticker ? `${truncateTicker(publisher.bloomberg_ticker)}` : ''}
          </Button>
        )}
        <QuickViewCloseButton className="ml-auto" onClose={onClose} />
      </div>
      <div className="prospects-sidebar__header-min-box">
        <div className="prospects-sidebar__header-min">
          <div className="prospects-sidebar__header-min-text">
            <div className="prospects-sidebar__header-min-text-head text-truncate">
              {settings.pending ? <Skeleton height={18} width={200} /> : publisher.name}
            </div>
            {permissions.allowApptopiaToSalesforceIntegration && !isEmpty(publisher) && (
              <div className="prospects-sidebar__header-min-btn">
                <PushToSalesforceButton
                  permissions={permissions}
                  salesforceAccountUrl={salesforceAccountUrl}
                  isLoading={isLoading}
                  handleClick={onSalesforceButtonClick}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

PubPreHeader.propTypes = {
  publisher: T.object.isRequired,
  settings: T.object.isRequired,
  onSalesforceButtonClick: T.func.isRequired,
  salesforceAccountUrl: T.oneOfType([T.string, T.bool]),
  isLoading: T.bool,
  onClose: T.func.isRequired,
};

export default PubPreHeader;
